export interface GlassDesign {
  id: string;
  name: string;
  publicPath: string;
}

/** Independent reusable glass artwork. Not a full-door SVG. */
export const GLASS_DESIGNS: GlassDesign[] = [
  { id: 'clear', name: 'Clear', publicPath: '/images/door-designer/glass/clear.svg' },
  { id: 'satin', name: 'Satin', publicPath: '/images/door-designer/glass/satin.svg' },
];

export const DEFAULT_GLASS_DESIGN_ID = 'clear';

export function getGlassDesign(id: string | undefined): GlassDesign | undefined {
  if (!id) return undefined;
  return GLASS_DESIGNS.find((design) => design.id === id);
}

export function selectedGlassDesignId(glazing: Array<{ id: string }>): string {
  return getGlassDesign(glazing[0]?.id)?.id ?? DEFAULT_GLASS_DESIGN_ID;
}
